import OverlayLayer from './OverlayLayer'
import Animate from './Animate'
import Parallax from './Parallax'
import FetchArt from './FetchArt'
import Swiper, { Pagination } from 'swiper'
Swiper.use([Pagination])

class Overlay {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$links = [...document.querySelectorAll('.js-link')]
    this.ui.$stickyHeader = document.querySelector('.js-overlay-header-mini')
    this.ui.$audioPlayer = document.querySelector('.js-player')
    this.windowRef = window.location.href
  }

  bindEvents() {
    this.ui.$links.forEach(element => {
      element.addEventListener('click', this.onClick.bind(this))
    })
  }

  onClick(e) {
    let target = e.currentTarget
    let delay
    if (!target.matches('.js-link')) return

    let ancestorId = target.getAttribute('data-parent-id')

    if (document.body.classList.contains('menu-is-open')) {
      window.menu[0].onClose()
    }

    if (target.classList.contains('js-link--home')) {
      target.querySelector('.thumbnail').classList.add('is-animate')
      delay = 1300
    } else {
      delay = 300
    }

    setTimeout(() => {
      window.overlaylayer = new OverlayLayer(ancestorId, target.hash)
      let slider = window.overlaylayer.ui.$overlay.querySelector('.js-slider')
      if (window.sliderdefault) {
        window.sliderdefault.destroy()
        window.sliderdefault = undefined
        
      }
      function updateAccessibility(swiper) {
        swiper.slides.forEach((slide, index) => {
          
          const isActive = index === swiper.activeIndex;
          // Gérer aria-hidden
          slide.setAttribute('aria-hidden', isActive ? "false" : "true");

          slide.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
            el.tabIndex = isActive ? 0 : -1;
          });
          if (isActive) {
            // Gérer focus : désactiver les éléments des slides cachés
            trapFocus(slide);
          }
        });
      }

      function trapFocus(container) {
        const containerFocusableElements = container.querySelectorAll('a, button, [role="button"], input, select, textarea');
        const playerData = container.querySelector('.js-player-data');
        let playerFocusableElements = []
        let playerOriginalNextSibling = null
        let playerOriginalParent = null
        let player = null
        
        if (playerData) {
          player = document.querySelector('.js-player')
          playerFocusableElements = player.querySelectorAll('.js-player-toggle, .js-player-transcript');
        
          // Sauvegarder la position d'origine du player
          playerOriginalParent = player.parentNode;
          playerOriginalNextSibling = player.nextSibling;
          // Déplacer le player dans le container
          container.appendChild(player);
        }
        
        const allFocusableElements = [...containerFocusableElements, ...playerFocusableElements];
        const lastFocusableElement = allFocusableElements[allFocusableElements.length - 1];
        const firstFocusableElement = allFocusableElements[0];
        if (allFocusableElements.length === 0) return;

        const handleKeyDown = (e) => {
          if (e.key === 'Escape') {
            container.setAttribute('aria-hidden', "true");
            allFocusableElements.forEach((el) => {
              el.tabIndex = -1;
            });
            window.overlaylayer.onClose(container.querySelector('.js-overlay-close'));
          }
          if (e.key === 'Tab') {
            const currentIndex = Array.from(allFocusableElements).indexOf(document.activeElement);
            
            if (e.shiftKey) {
              // Tab inversé (Shift + Tab)
              if (document.activeElement === firstFocusableElement) {
                e.preventDefault();
                allFocusableElements[allFocusableElements.length - 1].focus();
              }
            } else {
              // Tab normal
              if (document.activeElement === lastFocusableElement) {
                e.preventDefault();
                allFocusableElements[0].focus();
              }
            }
          }
        };

        container.addEventListener('keydown', handleKeyDown);
        
        // Nettoyage des événements et remise en place du player
        const cleanup = () => {
          container.removeEventListener('keydown', handleKeyDown);
          if (playerOriginalParent) {
            // Remettre le player à sa place d'origine
            if (playerOriginalNextSibling) {
              playerOriginalParent.insertBefore(player, playerOriginalNextSibling);
            } else {
              playerOriginalParent.appendChild(player);
            }
          }
        };
        
        // Ajouter le nettoyage à la fermeture de l'overlay
        const originalOnClose = window.overlaylayer.onClose;
        window.overlaylayer.onClose = function(...args) {
          cleanup();
          return originalOnClose.apply(this, args);
        };

        firstFocusableElement.focus();
      }
      let activeIndex = Array.from(slider.querySelectorAll('.swiper-slide')).indexOf(slider.querySelector('.swiper-slide' + target.hash))
      
      // Variable pour stocker le timeout d'accessibilité
      let accessibilityTimeout = null;
      
      window.sliderdefault = new Swiper(slider, {
        on: {
          init: function () {
            setTimeout(() => {
              updateAccessibility(this);
            }, 200);
          },
          slideChange: function () {
            // Annuler le timeout précédent s'il existe
            if (accessibilityTimeout) {
              clearTimeout(accessibilityTimeout);
            }
            
            // Créer un nouveau timeout
            accessibilityTimeout = setTimeout(() => {
              updateAccessibility(this);
            }, 500);
          },
        },
        spaceBetween: 16,
        initialSlide: activeIndex,
        autoHeight: true,
        observer: true,
        threshold: 20,
        pagination: {
          el: ".js-pagination",
        }
      })
      // Écouter l'événement de changement de diapositive
      window.sliderdefault.on('slideChange', function () {
        const activeSlide = this.slides[this.activeIndex];
        movePlayerToSlide(activeSlide);
        const activeIndex = this.activeIndex;
        
        const currentSlideId = this.slides[activeIndex].querySelector('.js-overlay-child').getAttribute('data-id')
        let pathUrl;
        let overlayTitle = this.slides[activeIndex].querySelector('.js-overlay-title')
        window.fetchdata.items.forEach(item => {
          if (item.id == currentSlideId) {
            pathUrl = new URL(item.url)
          }
        });
        window.dataLayer.push({
          'event': 'page_view',
          'page_path': pathUrl.pathname,
          'page_title': overlayTitle.innerText
        });
      });
      let hash = window.location.hash.substring(1)
      let slide = slider.querySelector('[data-hash="' + hash + '"]')
      let index = slide.getAttribute('data-index')
      window.sliderdefault.activeIndex = parseInt(index)
      window.sliderdefault.realIndex = parseInt(index)
      window.sliderdefault.updateAutoHeight(300)
      let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
      window.sliderdefault.update()
      let overlayClose = activeSlide.querySelector('.js-overlay-close')
      let overlayTitle = activeSlide.querySelector('.js-overlay-title')
      let overlayPagination = activeSlide.querySelector('.js-pagination')

      let close = overlayClose.cloneNode(true)
      let title = overlayTitle.cloneNode(true)
      let pagination = overlayPagination.cloneNode(true)

      this.ui.$stickyHeader.append(close)
      this.ui.$stickyHeader.append(title)
      this.ui.$stickyHeader.append(pagination)

      let bullets = pagination.querySelectorAll('.swiper-pagination-bullet')
      for (let i = 0; i < bullets.length; i++) {
        bullets[i].classList.remove('swiper-pagination-bullet-active')
      }

      bullets[window.sliderdefault.activeIndex].classList.add('swiper-pagination-bullet-active')



      let images = activeSlide.querySelectorAll('.js-parallax')
      if (images.length > 0) {
        window.parallax = new Parallax(images)
      }

      if (
        activeSlide.classList.contains('template-history') ||
        activeSlide.classList.contains('archive-artist') ||
        activeSlide.classList.contains('template-map-dark')
      ) {
        this.ui.$stickyHeader.classList.add('overlay-header-mini--dark')
      }

      window.animate = new Animate()

      let arts = [...activeSlide.querySelectorAll('.js-art-link')]
      if (arts.length > 0) {
        arts.forEach(element => {
          window.fetchart = new FetchArt(element, true)
        });
      }

      let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
      let pathUrl

      window.fetchdata.items.forEach(item => {
        if (item.id == id) {
          pathUrl = new URL(item.url)
        }
      });

      // if(window.overlaylayer.ui.$overlay.parentNode.classList.contains('js-overlay-stories')) {
      //   let storiesLink = [...activeSlide.querySelectorAll('.js-story-link')]
      //   if(storiesLink.length > 0) {
      //     storiesLink.forEach(element => {
      //       element.href = `${element.href}&parent=stories`
      //     });
      //   }
      // }
      window.dataLayer.push({
        'event': 'page_view',
        'page_path': pathUrl.pathname,
        'page_title': title.innerText
      });

    }, delay)
  }
}

function movePlayerToSlide(slide) {
  const player = document.querySelector('.js-player');
  if (!player) return;
  // Vérifie si le player est déjà dans le slide actif
  if (slide.contains(player)) return;
  slide.appendChild(player);
}

export default Overlay;
